import Icon from '@ant-design/icons/lib/components/Icon'
import styled from 'styled-components'

export const PatientViewContainer = styled.div`
  display: flex;
  margin: 20px;
  flex-direction: column;
  @media (max-width: 1200px) {
    flex-direction: column;
    margin-top: 130px;
    margin-bottom: 20px;
    gap:15px;
  }
  
`

export const PatientViewTitle = styled.div`
  display: flex;
  gap: 1rem;
  font-size: 1.5rem;
  font-weight: 500;
`

export function generateFullName(
  title: string,
  firstName: string,
  lastName: string
) {
  let newTitle = title.trim()
  if (newTitle.at(-1) !== '.') {
    newTitle = newTitle + '.'
  }
  let newFirstName = firstName.trim()
  let newLastName = lastName.trim()

  let fullName = `${newTitle} ${newFirstName} ${newLastName}`
  return fullName
}

export const TabEmptyText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-weight: 600;
  font-size: 0.875rem;
`

const iconSize = {
  small: '10px',
  medium: '20px',
  large: '30px',
}

export const VitalStatusIcon = styled(Icon)<{
  iconsize: 'small' | 'medium' | 'large'
}>`
  font-size: ${(props) => iconSize[props.iconsize]};
`

export const VitalStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
`

export const MewsScoreTag = styled.div<{ bgColor: any }>`
  border: 1px solid ${(props) => props.bgColor};
  border-top: 3px solid ${(props) => props.bgColor};
  background-color: ${(props) => getLightColor(props.bgColor)};
  color: black;
  padding: 4px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1em;
`

export const getColor = (score: number | undefined): string => {
  if (score === undefined) {
    return '#585858'
  }

  switch (score) {
    case 0:
      return '#00FF00'
    case 1:
      return '#ffec3d'
    case 2:
      return '#FFA500'
    default:
      return score >= 3 ? '#FF0000' : '#585858'
  }
}

function getLightColor(color: any) {
  if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)) {
    throw new Error('Invalid color format. Use #RRGGBB', color)
  }
  let r = parseInt(color.slice(1, 3), 16)
  let g = parseInt(color.slice(3, 5), 16)
  let b = parseInt(color.slice(5, 7), 16)
  let factor = 90 / 100
  r = Math.round(r + (255 - r) * factor)
  g = Math.round(g + (255 - g) * factor)
  b = Math.round(b + (255 - b) * factor)
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`
}
